<div class="container-fluid fixed-top gx-0 bg-primary-50 shadow-8">
    <div class="row justify-content-center">
        <div class="col d-flex justify-content-center align-items-center py-2">
                <app-logo-plataforma [plataforma]="plataforma"></app-logo-plataforma>
        </div>
    </div>
</div>